import React, { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import TagPayDashboardComponent from "./component";

const TagPayDashboardContainer = (props) => {
  const { corporateId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [corporateName, setCorporateName] = useState("");
  const [pgid, setPgid] = useState(null);
  const [error, setError] = useState(null);

  // Get pgid from location state
  useEffect(() => {
    if (location.state?.pgid) {
      setPgid(location.state.pgid);
      console.log("PGID received:", location.state.pgid);
    }
    if (location.state?.corporateName) {
      setCorporateName(location.state.corporateName);
    }
  }, [location.state]);

  // Fetch dashboard data
  const fetchDashboardData = useCallback(() => {
    if (!corporateId) {
      setError("Corporate ID not found");
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    
    let url = `/partner/api/v2/corporates/${corporateId}/dashboard`;
    if (pgid) {
      url += `?pgid=${pgid}`;
    }
    
    props.getDataFromAPI(
      url,
      "GET",
      undefined,
      (response) => {
        console.log("Dashboard API Response:", response);
        if (response) {
          setDashboardData(response);
        } else {
          setError("Failed to load dashboard data");
        }
        setLoading(false);
      },
      (error) => {
        console.error("Error fetching dashboard:", error);
        setError(error?.message || "Failed to fetch dashboard data");
        toastr.error("Error", "Unable to load dashboard data");
        setLoading(false);
      }
    );
  }, [corporateId, pgid, props]);

  useEffect(() => {
    if (corporateId) {
      fetchDashboardData();
    } else {
      setError("Corporate ID not found");
      setLoading(false);
    }
  }, [corporateId, fetchDashboardData]);

  // Navigation handlers
  const handleAddTag = () => {
    navigate(`/home/walletandtag/tagpymanagementv2/create-bulk-tag/${corporateId}/${pgid || '11'}`);
  };

  const handleAddRule = () => {
    navigate(`/home/customermanager/corporate/add-rule/${corporateId}?pgid=${pgid || '11'}`);
  };

  const handleViewDepartments = () => {
    navigate(`/home/customermanager/departments/${corporateId}?pgid=${pgid || '11'}`);
  };

  // ✅ Fixed: Added handleViewTag function
  const handleViewTag = () => {
    navigate(`/home/walletandtag/tagpymanagementv2/view-tag/${corporateId}/${pgid || '11'}`);
  };

  const handleViewRules = () => {
    navigate(`/home/customermanager/corporate/rules/${corporateId}?pgid=${pgid || '11'}`);
  };

  const handleViewUsageLimit = () => {
    navigate(`/home/customermanager/usage-limit/${corporateId}?pgid=${pgid || '11'}`);
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleRefresh = () => {
    fetchDashboardData();
  };

  return (
    <TagPayDashboardComponent
      corporateId={corporateId}
      corporateName={corporateName}
      dashboardData={dashboardData}
      loading={loading}
      error={error}
      onAddTag={handleAddTag}
      onAddRule={handleAddRule}
      onViewDepartments={handleViewDepartments}
      onViewTags={handleViewTag}      // ✅ Pass onViewTag as onViewTags
      onViewTag={handleViewTag}       // ✅ Added missing prop
      onViewRules={handleViewRules}
      onViewUsageLimit={handleViewUsageLimit}
      onBackClick={handleBackClick}
      onRefresh={handleRefresh}
    />
  );
};

function mapStateToProps(state) {
  return {
    props: state,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(TagPayDashboardContainer);